import { P0, S, abs, fillAt, max, rotPts } from '../../geometry';

export const pencil = {
  name: 'Pencil',
  colors: ['#E3A008', '#161616'],
  draw(m, t) {
    let tilt = 22 + 3 * S(t * 1.2),
      tx = 0,
      hop = 0,
      ph = t * 1.2,
      amp = 2,
      pose = P0();
    if (m === 'happy') {
      hop = -4 * abs(S(t * 6));
      ph = t * 8;
      amp = 4;
      tilt = 22 + 8 * S(t * 6);
    }
    // Thinking: scribbles back and forth, the line underneath growing wavy.
    if (m === 'thinking') {
      tx = 7 * S(t * 3);
      tilt = 24 + 6 * S(t * 6);
      ph = t * 5;
      amp = 3.5;
    }
    if (m === 'talking') {
      hop = -2 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      tilt = 0;
      hop = -6;
      amp = 0.5;
    }
    if (m === 'paused') {
      tilt = 64 + S(t * 0.7);
      amp = 0.8;
      ph = t * 0.4;
    }
    const tip = [62 + tx, 80 + hop];
    const local = {
      body: [
        [40, 18],
        [40, 62],
        [60, 62],
        [60, 18],
        [40, 18],
      ],
      band: [
        [40, 27],
        [60, 27],
      ],
      cone: [
        [40, 62],
        [50, 80],
        [60, 62],
      ],
    };
    const place = (pts) =>
      rotPts(
        pts.map(([x, y]) => [x - 50 + tip[0], y - 80 + tip[1]]),
        tip[0],
        tip[1],
        -tilt
      );
    const line = [...Array(8)].map((_, k) => [
      16 + k * 6.3,
      88 + amp * S(k * 1.4 + ph),
    ]);
    const eye = place([[50, 42]])[0];
    return {
      strokes: [
        { c: 'a', pts: place(local.body), sharp: true, n: 40 },
        { c: 'a', pts: place(local.band) },
        { c: 'a', pts: place(local.cone), sharp: true, n: 20 },
        { c: 'b', pts: line },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    fillAt(f, 0, 2);
    f.strokes[1] = { ...f.strokes[1], c: 'b' };
    return f;
  },
};
